import Vue from 'vue'

import './styles/quasar.styl'
import '@quasar/extras/material-icons/material-icons.css'
import Quasar from 'quasar'
import QImg from 'quasar'
import Meta from 'quasar'

const path = require("path");
// const CopyWebpackPlugin = require('copy-webpack-plugin')
// const SitemapPlugin = require('sitemap-webpack-plugin').default

// const paths = [
//   { path: '/en' },
//   { path: '/privacy-policy' },
//   { path: '/terms-and-conditions' },
// ] 

Vue.use(Quasar, {
  plugins: {
    Meta
  },
  config: {
    animations: 'all',

    build: {
      rtl: true,

      extendWebpack(cfg, {isServer, isClient}) {
        console.log('isServer = ', isServer);
        console.log('isClient = ', isClient);

        // cfg.module.rules.push(
        //   {
        //     test: /\.(png|jpe?g|gif)$/i,
        //     loader: "file-loader"
        //   }, 
        //   // {
        //   // test: /\.js$|jsx/,
        //   //   loader: 'babel-loader',
        //   //   exclude: /node_modules/
        //   // }, 
        //   // {
        //   //   test: /\.css$/,
        //   //   loader: "style-loader!css-loader"
        //   // }, 
        //   // {
        //   //   test: /\.(jpe?g|png|gif|woff|woff2|eot|ttf|svg)(\?[a-z0-9=.]+)?$/,
        //   //   loader: 'url-loader?limit=100000'
        //   // }
        //   // {
        //   // test: /\.(sass|less|css)$/,
        //   // include: path.resolve(__dirname),
        //   // loaders: ['style-loader', 'css-loader', 'less-loader'],
        //   // use: [
        //   //   'style-loader',
        //   //   'css-loader',
        //   //   {
        //   //     loader: "postcss-loader",
        //   //     options: {
        //   //       plugins: () => [
        //   //         require("autoprefixer")()
        //   //       ],
        //   //     },
        //   //   },
        //   //   'sass-loader',
        //   // ]
        //   // }
        // )

        cfg.resolve.alias = {
          ...cfg.resolve.alias, 
          utils: path.resolve(__dirname, "./src/utils"),
        };
        // cfg.plugins.push(
        //   new SitemapPlugin({
        //     base: 'https://saryahapp.com',
        //     paths,
        //     options: {
        //       filename: 'sitemap.xml',
        //       lastmod: true,
        //       changefreq: 'weekly',
        //     }
        //   })
        // );
        // cfg.plugins.push(
        //   new CopyWebpackPlugin([{ context: `${__dirname}/src/assets`, from: `*.*` }]) 
        // );   
      },
    },
    framework: {
      lang: 'ar'
    },
    components: {
      QImg
    }
  }
})